import {connect} from 'react-redux';
import {RouteComponentProps, withRouter, match} from 'react-router';
import ReduxState from '../../types/ReduxState';
import AuthenticationAwareRoute from './AuthenticationAwareRoute';

interface IAuthenticationAwareRouteOwnProps<T extends TQueryParams> extends RouteComponentProps<T> {
   isLoggingIn: boolean;
   isAuthRequired: boolean;
   onLoginComplete?: OnLoginCompleteRouteCallback<T>;
}

interface IAuthenticationAwareRouteReduxStateProps {
   isLoggedIn: boolean;
}

type TQueryParams = Record<string, string>;
export type IAuthenticationAwareRouteProps<T extends TQueryParams = {}> = IAuthenticationAwareRouteOwnProps<T> & IAuthenticationAwareRouteReduxStateProps;
export type OnLoginCompleteRouteCallback<T extends TQueryParams> = (history: any, location: any, match: match<T> | null) => void; // cant history and location have stronger types?

const mapStateToProps = (state: ReduxState, ownProps: IAuthenticationAwareRouteOwnProps<TQueryParams>): IAuthenticationAwareRouteOwnProps<TQueryParams> & IAuthenticationAwareRouteReduxStateProps => {
   return {
      history: ownProps.history,
      location: ownProps.location,
      match: ownProps.match,
      isLoggingIn: ownProps.isLoggingIn,
      isAuthRequired: ownProps.isAuthRequired,
      onLoginComplete: ownProps.onLoginComplete,
      isLoggedIn: !!state.currentUser?.userId
   };
};

export default withRouter(connect(mapStateToProps, null)(AuthenticationAwareRoute));
